/* ============================================================
   AA STYLING DRAWER — behavior
   Around Always · v6 · 13 Aug 2026
   v4 changes:
   - Pill pins to the FIRST gallery image (works for slider,
     grid and stacked desktop layouts), not the whole gallery.
   - Zoom lightbox: tap a styling shot to open fullscreen,
     tap image to zoom in/out, pinch works natively on phones.
   v1: open/close, scrim, Esc, swipe-down, focus trap, CTA proxies
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-aa-styling-root]');
    if (!root || root.dataset.aaInit === '1') return;
    root.dataset.aaInit = '1';

    var pill = root.querySelector('[data-aa-pill]');
    var drawer = root.querySelector('[data-aa-drawer]');
    var scrim = root.querySelector('[data-aa-scrim]');
    var closeBtn = root.querySelector('[data-aa-close]');
    var atcBtn = root.querySelector('[data-aa-atc]');
    var buyBtn = root.querySelector('[data-aa-buynow]');
    var zoomOverlay = root.querySelector('[data-aa-zoom-overlay]');
    var zoomImg = root.querySelector('[data-aa-zoom-img]');
    var zoomStage = root.querySelector('[data-aa-zoom-stage]');
    var zoomClose = root.querySelector('[data-aa-zoom-close]');
    if (!pill || !drawer || !scrim) return;

    /* ---- 1. Pin the pill ----
       Mobile  (<750px): on the visible gallery container, so the pill
       hugs the right edge of the photo area (not the wide slider track).
       Desktop (>=750px): on the FIRST gallery image so it is visible
       on page load (grid/stacked layouts scroll far down). */
    var mediaCol = root.closest('.product-detail__media');
    var anchor = null;
    if (mediaCol) {
      var isDesktop = window.matchMedia('(min-width: 750px)').matches;
      if (isDesktop) {
        anchor =
          mediaCol.querySelector('.grid_scroll > *') ||
          mediaCol.querySelector('.media-main-swiper') ||
          mediaCol.querySelector('media-gallery');
      } else {
        anchor =
          mediaCol.querySelector('media-gallery') ||
          mediaCol.querySelector('.media-main-swiper') ||
          mediaCol;
      }
    }
    if (anchor) {
      var cs = window.getComputedStyle(anchor);
      if (cs.position === 'static') anchor.style.position = 'relative';
      anchor.appendChild(pill);
    }

    /* ---- 2. Move overlays to <body> (escape z-index traps) ---- */
    document.body.appendChild(scrim);
    document.body.appendChild(drawer);
    if (zoomOverlay) document.body.appendChild(zoomOverlay);

    var lastFocus = null;
    var openedAt = 0; /* guards against the tap that opened the drawer
                         "ghost-clicking" an image that slides in under
                         the finger and instantly opening the zoom */

    function openDrawer() {
      lastFocus = document.activeElement;
      openedAt = Date.now();
      scrim.hidden = false;
      drawer.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          scrim.classList.add('is-open');
          drawer.classList.add('is-open');
        });
      });
      document.documentElement.classList.add('aa-style-lock');
      document.body.classList.add('aa-style-lock');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeDrawer() {
      scrim.classList.remove('is-open');
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('aa-style-lock');
      document.body.classList.remove('aa-style-lock');
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(function () {
        scrim.hidden = true;
        drawer.hidden = true;
      }, 400);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        if (zoomOverlay && !zoomOverlay.hidden) { closeZoom(); return; }
        closeDrawer();
        return;
      }
      if (e.key === 'Tab') {
        var focusables = drawer.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    /* The pill sits inside the theme's gallery/zoom container — swallow
       every event so a click on the pill never bubbles up and triggers
       the product image zoom underneath it. */
    pill.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    });
    ['mousedown', 'mouseup', 'touchstart', 'touchend', 'pointerdown', 'pointerup'].forEach(function (evt) {
      pill.addEventListener(evt, function (e) { e.stopPropagation(); }, { passive: false });
    });
    scrim.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    /* ---- 3. Swipe-down to close (mobile) ---- */
    var startY = null;
    var head = drawer.querySelector('.aa-style-drawer__head');
    if (head) {
      head.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
      head.addEventListener('touchmove', function (e) {
        if (startY === null) return;
        if (e.touches[0].clientY - startY > 70) { startY = null; closeDrawer(); }
      }, { passive: true });
      head.addEventListener('touchend', function () { startY = null; }, { passive: true });
    }

    /* ---- 4. CTA proxies ---- */
    function findAtcButton() {
      return (
        document.querySelector('.product-detail__buy-buttons button[name="add"]') ||
        document.querySelector('.mobile-fixed button[name="add"]') ||
        document.querySelector('button[name="add"].product-form__submit')
      );
    }
    function findBuyNowButton() {
      var zone = document.querySelector('.btn-checkout-dynamic');
      if (!zone) return null;
      return zone.querySelector('button, a, [role="button"]');
    }
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var target = findAtcButton();
        closeDrawer();
        if (target) window.setTimeout(function () { target.click(); }, 420);
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var target = findBuyNowButton() || findAtcButton();
        closeDrawer();
        if (target) window.setTimeout(function () { target.click(); }, 420);
      });
    }

    /* ---- 5. Zoom lightbox ---- */
    function openZoom(src) {
      if (!zoomOverlay || !zoomImg) return;
      zoomImg.src = src;
      zoomOverlay.hidden = false;
      zoomOverlay.classList.remove('is-zoomed');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          zoomOverlay.classList.add('is-open');
        });
      });
    }
    function closeZoom() {
      if (!zoomOverlay) return;
      zoomOverlay.classList.remove('is-open');
      window.setTimeout(function () {
        zoomOverlay.hidden = true;
        zoomOverlay.classList.remove('is-zoomed');
        zoomImg.removeAttribute('src');
      }, 260);
    }
    drawer.addEventListener('click', function (e) {
      if (Date.now() - openedAt < 600) return; /* ignore the opening tap's ghost click */
      var frame = e.target.closest('[data-aa-zoom-src]');
      if (frame) openZoom(frame.getAttribute('data-aa-zoom-src'));
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var frame = e.target.closest('[data-aa-zoom-src]');
      if (frame) { e.preventDefault(); openZoom(frame.getAttribute('data-aa-zoom-src')); }
    });
    if (zoomClose) zoomClose.addEventListener('click', closeZoom);
    if (zoomImg) {
      zoomImg.addEventListener('click', function (e) {
        e.stopPropagation();
        zoomOverlay.classList.toggle('is-zoomed');
      });
    }
    if (zoomStage) {
      zoomStage.addEventListener('click', function (e) {
        if (e.target === zoomStage) closeZoom(); /* tap dark area closes */
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();